import { render } from "./VideoPlayer.vue?vue&type=template&id=89136308"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/DJgz4Uyo/0/dz/pc/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__